import React, { useEffect, useState } from 'react';
import { db } from '../FirebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import Footer from './Footer';
import Header from './Header';
import { Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const ClientDashboard = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentUserEmail, setCurrentUserEmail] = useState(null);

    useEffect(() => {
        const auth = getAuth();

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setCurrentUserEmail(user.email);
            } else {
                setCurrentUserEmail(null);
            }
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const fetchProjects = async () => {
            if (!currentUserEmail) {
                console.error("No user is logged in.");
                setLoading(false);
                return;
            }

            try {
                // Fetch all documents from the 'projects' collection
                const projectsSnapshot = await getDocs(collection(db, 'projects'));
                const projectsList = projectsSnapshot.docs
                    .map(doc => ({ id: doc.id, ...doc.data() }))
                    .filter(project => project.email === currentUserEmail);

                setProjects(projectsList);
            } catch (error) {
                console.error("Error fetching projects: ", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, [currentUserEmail]);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <>
            <Header />
            <div className="max-w-4xl md:mx-auto mx-3 p-6 md:my-12 md:mb-12 mb-32 my-3 bg-white shadow-lg rounded-lg">
                <div>
                    <div className="md:mb-6 mb-3 flex flex-col justify-center items-center">
                        <h2 className="text-3xl font-semibold text-gray-800">Client Dashboard</h2>
                        <div className="border-t-4 border-orange-500 mt-2 w-10 rounded-full"></div>
                    </div>
                    <div>
                        <Link to='/client-form' className="text-blue-500 hover:underline">
                            Start A New Project
                        </Link>
                    </div>
                </div>
                <div className="md:mb-6 mb-3">
                    <h3 className="text-2xl font-semibold mb-4">Pending Projects</h3>
                    <ul>
                        {projects.length ? (
                            projects.map(project => (
                                <li key={project.id} className="mb-4 p-4 border rounded">
                                    <h4 className="text-xl font-semibold">{project.companyName}</h4>
                                    <p><strong>Country:</strong> {project.country}</p>
                                    <p><strong>Phone:</strong> {project.phone}</p>
                                    <p><strong>Details:</strong> {project.projectDetails}</p>
                                </li>
                            ))
                        ) : (
                            <p>No projects found.</p>
                        )}
                    </ul>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ClientDashboard;
